// Source/Split-Section/Component.ts
import { Pagination, Swiper } from "Swiper";
class Split_Section extends HTMLElement {
  controller;
  connectedCallback() {
    this.controller = new AbortController;
    this.setupSwiper();
  }
  setupSwiper() {
    const { $pagination, autoplay } = this;
    const swiper = new Swiper(this, {
      modules: [Pagination],
      direction: "horizontal",
      autoplay: autoplay > 0 ? {
        disableOnInteraction: false,
        delay: autoplay * 1000
      } : false,
      slidesPerView: 1,
      spaceBetween: 30,
      enabled: this.device === "Mobile",
      updateOnWindowResize: true,
      pagination: {
        clickable: true,
        el: $pagination
      },
      breakpoints: {
        1000: {
          enabled: this.device === "Desktop"
        }
      }
    });
    swiper.on("click", (event) => {
      const slide = event.clickedSlide;
      const link = slide?.dataset.link;
      if (link)
        location.href = link;
    });
    this.controller.signal.addEventListener("abort", () => {
      swiper.destroy();
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  get $pagination() {
    return this.parentElement?.querySelector(`.Split-Pagination[ data-device = '${this.device}' ]`);
  }
  get autoplay() {
    return parseInt(this.dataset.autoplay);
  }
  get device() {
    return this.dataset.device;
  }
}

// Source/Split-Section/mod.ts
customElements.define("split-section", Split_Section);
